/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntryType } from './EntryType';
import {
    EntryTypeFromJSON,
    EntryTypeFromJSONTyped,
    EntryTypeToJSON,
    EntryTypeToJSONTyped,
} from './EntryType';
import type { FileType } from './FileType';
import {
    FileTypeFromJSON,
    FileTypeFromJSONTyped,
    FileTypeToJSON,
    FileTypeToJSONTyped,
} from './FileType';
import type { MediaGroup } from './MediaGroup';
import {
    MediaGroupFromJSON,
    MediaGroupFromJSONTyped,
    MediaGroupToJSON,
    MediaGroupToJSONTyped,
} from './MediaGroup';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface CreateExternalMediaRequest
 */
export interface CreateExternalMediaRequest {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof CreateExternalMediaRequest
     */
    entryId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {EntryType}
     * @memberof CreateExternalMediaRequest
     */
    entryType: EntryType;
    /**
     * 
     * @type {FileType}
     * @memberof CreateExternalMediaRequest
     */
    fileType: FileType;
    /**
     * 
     * @type {MediaGroup}
     * @memberof CreateExternalMediaRequest
     */
    mediaGroup: MediaGroup;
    /**
     * 
     * @type {string}
     * @memberof CreateExternalMediaRequest
     */
    externalUrl: string;
}



/**
 * Check if a given object implements the CreateExternalMediaRequest interface.
 */
export function instanceOfCreateExternalMediaRequest(value: object): value is CreateExternalMediaRequest {
    if (!('entryId' in value) || value['entryId'] === undefined) return false;
    if (!('entryType' in value) || value['entryType'] === undefined) return false;
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    if (!('mediaGroup' in value) || value['mediaGroup'] === undefined) return false;
    if (!('externalUrl' in value) || value['externalUrl'] === undefined) return false;
    return true;
}

export function CreateExternalMediaRequestFromJSON(json: any): CreateExternalMediaRequest {
    return CreateExternalMediaRequestFromJSONTyped(json, false);
}

export function CreateExternalMediaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateExternalMediaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'entryId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['entryId']),
        'entryType': EntryTypeFromJSON(json['entryType']),
        'fileType': FileTypeFromJSON(json['fileType']),
        'mediaGroup': MediaGroupFromJSON(json['mediaGroup']),
        'externalUrl': json['externalUrl'],
    };
}

export function CreateExternalMediaRequestToJSON(json: any): CreateExternalMediaRequest {
    return CreateExternalMediaRequestToJSONTyped(json, false);
}

export function CreateExternalMediaRequestToJSONTyped(value?: CreateExternalMediaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entryId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['entryId']),
        'entryType': EntryTypeToJSON(value['entryType']),
        'fileType': FileTypeToJSON(value['fileType']),
        'mediaGroup': MediaGroupToJSON(value['mediaGroup']),
        'externalUrl': value['externalUrl'],
    };
}

